/**
 * Onboarding link targets for the "Get Set Up" page.
 *
 * Centralized because these URLs change at launch (Web Store listing,
 * TestFlight public link, docs paths) — one place to update instead of
 * hunting through JSX.
 */
export const ONBOARDING_LINKS = {
  webApp: 'https://app.grovereader.com',
  /** TestFlight public link during beta; App Store listing at GA. */
  mobile: 'https://grovereader.com/mobile',
  /** Chrome Web Store listing — placeholder until the listing is published. */
  extensionWebStore: 'https://chromewebstore.google.com/',
  /** Short, memorable URL shown to users not on desktop Chrome. */
  extensionShortUrl: 'grovereader.com/extension',
  obsidianGuide: 'https://grovereader.com/docs/obsidian',
} as const;

/**
 * Best-effort UA check: are we on a desktop browser that can install the
 * Chrome extension? Used only to pick the extension card's variant (direct
 * Web Store link vs. a "open this on desktop" hint) — never for gating.
 */
export function isDesktopChromium(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
  const isChromium = /Chrome|Chromium|Edg/i.test(ua) && !/OPR|Firefox/i.test(ua);
  return isChromium && !isMobile;
}
